// @vendors
import './brokerConvenienceTestBoxesQuestion.scss';
import React, {useState} from 'react'
import PropTypes from 'prop-types';
const { FormattedText } = require('core/i18n').i18n;

// @components
import { RadioButton } from 'commonsComponents/radioButton';
import  OKModal from 'components/commons/OKModal/OKModal';

// @utilities
import { isValidTranslation } from '../../../utilities/mifidTestTextHelper'


const BrokerConvenienceTestBoxesQuestion = ({question, answer, onChange, questionId, sectionId}) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const buildHeaderIcon = (id) => {
        switch (id) {
            case '59':
                return null;
            case '60':
                return (
                    <i className="br-convenience-box-question__box-title-icon icon" />
                );
            case '61':
                return(
                    <React.Fragment>
                        <i className="br-convenience-box-question__box-title-icon icon" />
                        <i className="br-convenience-box-question__box-title-icon icon" />
                    </React.Fragment>
                );
            default:
                return null;
        }
    }
    const buildBoxes = (answer, onChange, questionId, sectionId) => {
        return answer.map((ans, index) => (
            <div
                className="br-convenience-box-question__box-short br-convenience-box-question__box-neutral"
                onClick={() => onChange(sectionId, questionId, ans.get("id"))}
                key={index}
            >
                <div>
                    <div className="br-convenience-box-question__box-title-icon_container">
                        {buildHeaderIcon(ans.get("id"))}
                        <RadioButton
                            className="br-convenience-box-question__box-title-radio-button"
                            isChecked={ans.get("selected") === "S"}
                            value={ans.get("id")}
                        />
                    </div>
                    <div className="br-convenience-box-question__box-description">
                        {ans.get("description")}
                    </div>
                </div>
            </div>
        ));
    }
    const modalButtonKey = `broker-convenienceMifidAltFundsModalQuestionButton_${questionId}`;
    const modalContentKey = `broker-convenienceMifidAltFundsModalQuestionContent_${questionId}`;
    const hasQuestionModal = isValidTranslation(modalButtonKey) && isValidTranslation(modalContentKey);

    const modalQuestion = hasQuestionModal && (
        <OKModal
            isOpen={modalIsOpen}
            content={(<FormattedText value={modalContentKey}/>)}
            descriptionAlignment="center"
            footerType="navigation"
            onCloseCallback={() => setModalIsOpen(false)}
            onPrimaryButtonClick={() => setModalIsOpen(false)}
            primaryButtonText={modalButtonKey}
            shouldCloseOnOverlayClick={false}
            titleAlignment="center"
        />
    )
    return (
        <div className="br-convenience-box-question__container">
            {modalQuestion}
            <div className="br-convenience-box-question__header">
                <div className="br-convenience-box-question__title">
                    {question}
                    { hasQuestionModal &&
                        <div
                            className="br-convenience-box-question__tooltip"
                            onClick={() => setModalIsOpen(true)}
                        >
                            <div className="br-convenience-box-question__tooltip-icon" />
                        </div>
                    }
                </div>
            </div>
            <div className="br-convenience-box-question__box-section">
                <div className="br-convenience-box-question__box-container">
                    {buildBoxes(answer, onChange, questionId, sectionId)}
                </div>
            </div>
        </div>
    )
}

BrokerConvenienceTestBoxesQuestion.propTypes = {
    question: PropTypes.string,
    answer: PropTypes.object,
    onChange: PropTypes.func,
    questionId: PropTypes.string,
    sectionId: PropTypes.string
}

export default BrokerConvenienceTestBoxesQuestion
